import { Plugin, PluginKey } from 'prosemirror-state';
import { isUrl } from '../helpers/is-url';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { sanitizeUrl } from '@intercom/pulse/lib/sanitize';
export function autoLink() {
  return new Plugin({
    key: new PluginKey('autoLink'),
    props: {
      handlePaste(view, event) {
        if (event.clipboardData && isUrl(event.clipboardData.getData('Text')) &&
        //eslint-disable-line
        view.state.schema.marks.anchor && view.state.selection.from !== view.state.selection.to) {
          view.dispatch(view.state.tr.addMark(view.state.selection.from, view.state.selection.to, view.state.schema.marks.anchor.create({
            href: sanitizeUrl(event.clipboardData.getData('Text')).string //eslint-disable-line
          })));
          return true;
        }
        return false;
      }
    }
  });
}